/**
 * Checks is the user uses a mobile or desktop
 */
export function isMobile() : boolean {
    if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
        const isMobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        const isSmallScreen = window.innerWidth <= 768;

        return isMobileUserAgent || isSmallScreen;
    }
    return false;
}
